import { TwitterAuthProvider } from "firebase/auth";
import axiosInstance from "./axios.instance";

const API_AGENTS_CHAT_DELETE = async (data) => {
  try {
    const resp = await axiosInstance.delete("/customer-group/firebase/deletegroups", {
      data: data
    });
    return resp.data;
  } catch (error) {
    throw error;
  }
};

const API_AGENTS_CHAT_MIGRATE = async (data) => {
  try {
    const resp = await axiosInstance.post(
      "/customer-group/firebase/transfergroups",
      data
    );
    return resp.data;
  } catch (error) {
    throw error;
  }
};
export { API_AGENTS_CHAT_DELETE, API_AGENTS_CHAT_MIGRATE };
